<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <div>
      <b-row>
        <b-col>
          <b-form @submit.prevent="save">
            <b-card>
              <b-form-row>
                <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                  :error="$v.form.descricao" v-model="form.descricao" label="Descrição: *" cols="12" />
              </b-form-row>
              <b-form-row class='d-block'>
                <LgFinderPageMarca v-model="form.marca" :error="$v.form.marca" :prefix="updatedPrefix" :codEmpresa="id"
                  id="finderPageMarca" label="Marca: *" invalidFeedback="Marca deve ser informada!" cols="12" />
              </b-form-row>
              <b-form-row>
                <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
                  class="d-flex col-12">
                </b-form-radio-group>
              </b-form-row>

              <div class="d-flex justify-content-center mt-3">
                <b-button id="salvarModelo" type="submit" variant="success" style="height: 30px" pill size="sm">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="check-circle" />
                  </div>
                  <b-tooltip target="salvarModelo" title="Salvar" triggers="hover"></b-tooltip>

                </b-button>
                <b-button id="cancelarModelo" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                  </div>
                  <b-tooltip target="cancelarModelo" title="Cancelar" triggers="hover"></b-tooltip>

                </b-button>
              </div>
            </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import LgFinderPageMarca from "@/components/Finders/LgFinderPageMarca.vue"
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import { required } from "vuelidate/lib/validators"

export default {
  components: {
    LgFormInput,
    LgFinderPageMarca,
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix: {
      type: Array,
      required: true,
    },
    empresaNome: String,
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"]
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      descricao: { required },
      situacao: { required },
      marca: { required },
    },
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        descricao: "",
        marca: {},
        situacao: 1,
      },
    }
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/modelo`)
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id)
      this.form = data
    } else {
      this.form.situacao = 1
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }
      try {
        await this.$saveResource(
          this.form,
          "",
          true,
          {},
          this.isModal
        )
        this.cancelar();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Erro ao salvar`,
        })
        console.error(error)
      }
    },
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
